import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

const TYPE_DATE = 'date';
const TYPE_DATETIME = 'datetime';
const TYPE_CUSTOM = 'cust';

const FORMAT_DATETIME = 'DD/MM/YYYY H:mm';
const FORMAT_DATE = 'DD/MM/YYYY';

@Pipe({
  name: 'dateFormat',
})
export class DateFormatPipe implements PipeTransform {
  transform(value: string, type: string, format?: string): string {
    if (!value) {
      return '-';
    }

    const dateFormat = this.dateFormatForType(type, format);

    return moment(new Date(value)).format(dateFormat);
  }

  dateFormatForType(type: string, format?: string): string {
    if (TYPE_CUSTOM === type) {
      return format;
    }

    if (TYPE_DATETIME === type) {
      return FORMAT_DATETIME;
    }

    return FORMAT_DATE;
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/pipes/date-format.pipe.ts